import { formatDistanceToNow, format, parseISO } from 'date-fns';

/**
 * Formats a date for instance list display with relative time for recent dates
 * and absolute format for older dates
 */
export const formatInstanceTimestamp = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    const now = Date.now();
    const dateTime = date.getTime();
    const hoursDifference = (now - dateTime) / (1000 * 60 * 60);

    // Use relative time for dates within 24 hours
    if (hoursDifference < 24) {
      return formatDistanceToNow(date, { addSuffix: true });
    }

    // Use absolute format for older dates
    return format(date, 'MMM d, yyyy, h:mm a');
  } catch (error) {
    console.error('Error formatting instance timestamp:', error);
    return 'Invalid date';
  }
};

/**
 * Formats a date for tooltip display (always absolute format)
 */
export const formatAbsoluteTimestamp = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    return format(date, 'MMMM d, yyyy, h:mm:ss a');
  } catch (error) {
    console.error('Error formatting absolute timestamp:', error);
    return 'Invalid date';
  }
};

/**
 * Formats a date for general display (used elsewhere in the app)
 */
export const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date';
  }
};
